import { siteConfig } from "@/config/siteConfig";

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="oriva-logo">
    {siteConfig.brand.logoUrl ? (
      <img
        src={siteConfig.brand.logoUrl}
        alt="ORIVA AI logo"
        className="h-9 w-9 rounded-xl"
      />
    ) : (
      <span className="relative grid h-8 w-8 place-items-center overflow-hidden rounded-xl bg-slate-900">
        <span className="absolute inset-x-0 top-0 flex h-1">
          <span className="flex-1 bg-oriva-cyan" />
          <span className="flex-1 bg-oriva-gold" />
          <span className="flex-1 bg-oriva-coral" />
        </span>
        <span className="font-display text-sm font-semibold text-white">O</span>
      </span>
    )}
    <span
      className={`font-display text-lg font-semibold tracking-tight ${
        light ? "text-white" : "text-slate-900"
      }`}
    >
      ORIVA<span className="text-oriva-blue"> AI</span>
    </span>
  </span>
);
